(function() {
    const flag = document.querySelector('.selwyns-flag');
    const hero = document.querySelector('.hero_home');
    if (!flag || !hero) return;

    const flagImg = flag.querySelector('img');
    let flagWidth = 0;

    function updateFlag() {
        // Get flag width dynamically (in case it wasn't ready initially)
        if (flagWidth === 0) {
            flagWidth = flag.offsetWidth;
        }

        const heroRect = hero.getBoundingClientRect();
        const heroHeight = heroRect.height;

        // Only animate when hero is in viewport
        if (heroRect.bottom < 0 || heroRect.top > window.innerHeight) return;

        // Calculate how much of the hero has been scrolled past (0 to 1)
        const scrollProgress = Math.max(0, Math.min(1, -heroRect.top / heroHeight));

        // Move flag off-screen proportionally to scroll
        const translateX = scrollProgress * (flagWidth + 50);

        flag.style.transform = `translateY(-50%) translateX(${translateX}px)`;
    }

    function init() {
        flagWidth = flag.offsetWidth;
        updateFlag();
    }

    window.addEventListener('scroll', function() {
        requestAnimationFrame(updateFlag);
    });

    // Wait for the flag image to load before initializing
    if (flagImg) {
        if (flagImg.complete) {
            init();
        } else {
            flagImg.addEventListener('load', init);
        }
    } else {
        init();
    }
})();

// Fixed CTA behavior
(function() {
    const fixedCta = document.getElementById('fixed-cta-1');
    if (!fixedCta) return;

    let isFixed = false;

    // Store original dimensions
    const ctaOriginalRect = fixedCta.getBoundingClientRect();
    const ctaOffsetTop = ctaOriginalRect.top + window.scrollY;
    const ctaHeight = ctaOriginalRect.height;

    // Create placeholder to prevent layout shift
    const placeholder = document.createElement('div');
    placeholder.style.cssText = `
        display: none;
        width: ${ctaOriginalRect.width}px;
        height: ${ctaHeight}px;
    `;
    fixedCta.parentNode.insertBefore(placeholder, fixedCta.nextSibling);

    function updateCtaPosition() {
        const scrollY = window.scrollY;

        // Check if original position is out of viewport (scrolled past)
        const shouldBeFixed = scrollY > ctaOffsetTop + ctaHeight;

        if (shouldBeFixed && !isFixed) {
            placeholder.style.display = 'block';
            fixedCta.classList.add('is-fixed');
            isFixed = true;
        } else if (!shouldBeFixed && isFixed) {
            fixedCta.classList.remove('is-fixed');
            placeholder.style.display = 'none';
            isFixed = false;
        }
    }

    window.addEventListener('scroll', function() {
        requestAnimationFrame(updateCtaPosition);
    });

    // Initial call
    updateCtaPosition();
})();
